<template>
  <div class="bg-body">
    <NuxtPage />
    <NuxtRouteAnnouncer />
    <CookieControl :locale="locale" />
  </div>
</template>

<script setup lang="ts">
const { locale } = useI18n();
</script>